import DigitalMarketingServicePage from '../digital-marketing/DigitalMarketingServicePage';
import { getDigitalMarketingService } from '../digital-marketing/services';

const ContentMarketing = () => {
  const service = getDigitalMarketingService('content-marketing');
  if (!service) return null;
  return <DigitalMarketingServicePage service={service} />;
};

export default ContentMarketing;
